import { BatterySyncOutlineIcon } from './BatterySyncOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 5250464D-70A3-4BC2-8969-878E57526CDF
 * name battery-sync-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-sync-outline.svg
 * tags
 * - Battery 
 */
export const BatteryEcoOutlineIcon = BatterySyncOutlineIcon;
export default BatteryEcoOutlineIcon